import { Component, OnInit, Input } from '@angular/core';
import { SharedService } from 'src/app/shared/shared.service';
import { ITemplateSection, ITemplateSectionSeparator, SideBarType } from 'src/app/shared/shared.definitions';
import { FormGroup, FormControl } from '@angular/forms';
import { MatSidenav } from '@angular/material/sidenav';

@Component({
  selector: 'app-separator-editor',
  templateUrl: './separator-editor.component.html',
  styleUrls: ['./separator-editor.component.scss']
})
export class SeparatorEditorComponent implements OnInit {

  @Input() sidenav: MatSidenav;

  selectedSection: ITemplateSection;
  content: ITemplateSectionSeparator;
  separatorForm: FormGroup;
  isModified: boolean;

  constructor(
    private sharedService: SharedService
  ) { }

  ngOnInit() {
    this.sharedService.selectedSection.subscribe(section => {
      this.selectedSection = section;
      this.content = <ITemplateSectionSeparator>(this.selectedSection.content || {});
      this.separatorForm = new FormGroup({
        width: new FormControl(this.content.width || '100%'),
        size: new FormControl(this.content.size || '1px'),
        style: new FormControl(this.content.style || 'solid'),
        color: new FormControl(this.content.color || '#333333'),
        options: new FormGroup({
          verticalAlign: new FormControl(this.content.options && this.content.options.verticalAlign || 'middle'),
          paddingTop: new FormControl(this.content.options && this.content.options.paddingTop || '5px'),
          paddingBottom: new FormControl(this.content.options && this.content.options.paddingBottom || '5px'),
          paddingLeft: new FormControl(this.content.options && this.content.options.paddingLeft || '5px'),
          paddingRight: new FormControl(this.content.options && this.content.options.paddingRight || '5px'),
          backgroundColor: new FormControl(this.content.options && this.content.options.backgroundColor || '#ffffff'),
        })
      });

      this.separatorForm.valueChanges.subscribe(() => this.isModified = true);
    });
  }

  onSave() {
    Object.keys(this.separatorForm.value).forEach(key => this.content[key] = this.separatorForm.value[key]);
    this.selectedSection.content = this.content;
    this.isModified = false;
    this.sharedService.editSection(this.selectedSection);
    this.sidenav.close();
  }

  onDelete() {
    this.sharedService.deleteSection(this.selectedSection);
    this.sidenav.close();
  }

  onBack() {
    let confirmation = true;
    if (this.isModified) {
      confirmation = confirm('Nem mentett változásaid vannak! Biztos visszalépsz?');
    }
    if (confirmation) {
      this.isModified = false;
      this.sidenav.close();
    }
  }

}
